import { formatTimestampToValueDate } from './formatTimestampToValueDate';
import { formatValueDateToString } from './formatValueDateToString';
import { scheduling } from '@morf/proto/scheduling/v1/scheduling_ts_proto';
import { values } from '@morf/proto/values/v1/values_ts_proto';

export const getHighlightedDates = (
  monthlyAvailabilitySlots: scheduling.v1.ListAvailabilitySlotsResponse[]
): values.v1.Date[] => {
  const uniqueDates: Record<string, values.v1.Date> = {};

  for (const { slots } of monthlyAvailabilitySlots) {
    for (const slot of slots) {
      const date = formatTimestampToValueDate(slot);
      const key = formatValueDateToString(date);

      if (!uniqueDates[key]) {
        uniqueDates[key] = date;
      }
    }
  }

  return Object.values(uniqueDates);
};
